export const en = {
    titre: "AccèsD home",
    titreOnglet: "AccèsD | Desjardins",
};
